module.exports = __webpack_public_path__ + "img/tooltip-icon.5bc83ebe.png";